import * as React from "react";
import {
  Block,
  Page,
  Navbar,
  NavLeft,
  NavTitle,
  Link,
  BlockTitle,
  NavRight,
  Card,
  CardContent,
  CardHeader,
  Col,
  Row,
  List,
  ListItem,
} from "framework7-react";
import NewExcel from "../prefabs/NewExcel";
import { API_URL } from "src/utils/constants";
import { getToken, api } from "src/utils/utils";
import { CLOUD_FUNCTION } from "../../utils/constants";

export default class InternalControlPage extends React.Component {
  public state = {
    loading: false as boolean,
    data: [] as any[],
  };

  public componentDidMount() {
    this.$f7?.tooltip.create({
      targetEl: ".addCompetitor",
      text: "Subir nuevo Excel de Productos",
    });

    this.handleData();
  }

  public async handleData() {
    if (getToken() == null) {
      return;
    }

    this.setState({
      loading: true,
    });
    const dialog = this.$f7?.dialog.preloader("Cargando base de datos");
    dialog?.open();

    const data = await api.get<any[]>(
      API_URL + CLOUD_FUNCTION + "getDataBase",
      {}
    );

    console.log("data", data);

    this.setState({
      data,
      loading: false,
    });

    setTimeout(() => {
      dialog?.close();
    }, 500);
  }

  public render() {
    return (
      <Page>
        <Navbar>
          <NavLeft leftBreakpoint={800}>
            <Link panelOpen="left">
              <i className="icon icon-menu" />
            </Link>
          </NavLeft>
          <NavTitle>Control Interno</NavTitle>
          <NavRight>
            <Link className="addCompetitor" popupOpen=".excel-popup">
              <i className="icon icon-upload" />
            </Link>
          </NavRight>
        </Navbar>

        <BlockTitle>Base de datos de productos internos</BlockTitle>
        <Block>
          <h1>Control Interno</h1>
        </Block>
        <Block>
          <Row resizable={true}>
            {!this.state.data.length && !this.state.loading && (
              <h2>Sin productos registrados</h2>
            )}
            {this.state.data.length &&
              this.state.data.map((item: any) => {
                return (
                  <Col key={item.id} width="100">
                    <Card outline={true}>
                      <CardHeader>
                        <div className="fb">{item[1]}</div>
                      </CardHeader>
                      <CardContent padding={false}>
                        <Row>
                          <Col width="100">
                            <Row>
                              <Col width="33">
                                <List mediaList>
                                  <ListItem
                                    header="CLAVE INTERNA DE INKPRIMELO"
                                    subtitle={item[0]}
                                  />
                                </List>
                              </Col>
                              <Col width="33">
                                <List mediaList>
                                  <ListItem
                                    header="VERSION CAJA AMARILLA"
                                    subtitle={item[2]}
                                  />
                                </List>
                              </Col>
                              <Col width="33">
                                <List mediaList>
                                  <ListItem
                                    header="VERSION CAJA VERDE"
                                    subtitle={item[3]}
                                  />
                                </List>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </CardContent>
                    </Card>
                  </Col>
                );
              })}
          </Row>
        </Block>

        <NewExcel />
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/InternalControlPage.tsx